import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons/";
import theme from "@theme/";

const DropdownContainer = styled.div`
  position: relative;
  display: inline-block;
`;

// Dropdown button
const DropdownButton = styled.button`
  background: white;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  // min-width: 180px;
  min-width: ${(props) => props.minWidth || "180px"};

  justify-content: space-between;
  transition: all 0.2s ease;

  /* subtle shadow by default */
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15); /* slightly stronger on hover */
  }

  /* Open state */
  ${(props) =>
    props.isOpen &&
    `
    border-color: ${theme.colors.themeColor};
    box-shadow: 0 0 0 2px ${theme.colors.themeColor}, 0 4px 12px rgba(0,0,0,0.15);
  `}

  /* Active state (filter applied) */
  ${(props) =>
    props.isActive &&
    `
    border-color: ${theme.colors.themeColor}; 
    background-color:${theme.colors.buttonbackgroundfilter}; /* subtle light orange */
    color: ${theme.colors.themeColor};
  `}
`;

const DropdownMenu = styled.div`
  padding: 8px 10px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  margin-top: 4px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
  min-width: 200px;
`;

const ChevronIcon = styled(InnoIcons.KeyboardArrowDownIcon)`
  transition: transform 0.2s ease;
  transform: ${(props) => (props.isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  color: ${(props) =>
    props.isActive ? `${theme.colors.themeColor}` : "black"};
`;

// Footer
const DropdownFooter = styled.div`
  padding: 5px 0px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

// Clear / Update buttons
const ClearAllButton = styled.p`
  background: ${(props) => (props.primary ? "#EC810B" : "transparent")};
  color: ${(props) => (props.primary ? "#fff" : "#6b7280")};
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  padding-block: 0px;
  margin-block: 0px;

  &:hover {
    background-color: ${(props) => (props.primary ? "#d97706" : "#f3f4f6")};
    color: ${(props) => (props.primary ? "#fff" : "#374151")};
  }
`;

const SC = {
  DropdownContainer,
  DropdownButton,
  DropdownMenu,
  ChevronIcon,
  DropdownFooter,
  ClearAllButton,
};

export default SC;
